import styled from 'styled-components';
import { colorAccent, colorAdditional, colorBackgroundBody, colorBorder, colorFieldsBorder, colorText, colorWhite } from '../../theme/palette';
import { applyTextStyle } from '../../theme/typography'; // Componente base para inputs seguindo a estrutura do theme

export const FormGroup = styled.div`
  margin-bottom: 20px;
  width: 100%;
  position: relative;
`;
export const FormGroupField = styled.div`
  width: 100%;
  display: flex;
  margin: auto;
`;
export const FormGroupLabel = styled.span`
  margin-bottom: 4px;
  display: inline-block;
  color: ${colorText};
  ${applyTextStyle('label')}

  span {
    color: ${colorAdditional};
  }
`;
export const FormGroupDescription = styled.span`
  ${applyTextStyle('caption')}
  color: ${colorAdditional};
  line-height: 13px;
  margin-top: 2px;
`;
export const FormGroupIcon = styled.div`
  padding: 6px;
  height: 32px;
  background: ${colorFieldsBorder};
  border: 1px solid ${colorFieldsBorder};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${colorAdditional};
    width: 18px;
    height: 18px;
    transition: all 0.3s;
  }
`; // Estilos base para inputs

export const BaseInputStyles = `
  width: 100%;
  padding: 5px 10px;
  ${applyTextStyle('body')}
  height: 32px;
  transition: border 0.3s;
  background: transparent;
  border: 1px solid ${colorFieldsBorder};
  color: ${colorText};
  border-radius: 0;
  
  &::-webkit-input-placeholder {
    color: ${colorAdditional};
    ${applyTextStyle('body')}
  }
  &::-moz-placeholder {
    color: ${colorAdditional};
    ${applyTextStyle('body')}
  }
  &:-moz-placeholder {
    color: ${colorAdditional};
    ${applyTextStyle('body')}
  }
  &:-ms-input-placeholder {
    color: ${colorAdditional};
    ${applyTextStyle('body')}
  }
  
  &[disabled] {
    background: ${colorBackgroundBody};

    &:focus, &:active {
      border-color: ${colorBorder};
    }
  }

  &:focus, &:active {
    outline: none;
    border-color: ${colorAccent};
  }
`; // Input base estilizado

export const StyledInput = styled.input`
  ${BaseInputStyles}
`; // Textarea base estilizado

export const StyledTextarea = styled.textarea`
  ${BaseInputStyles}
  height: ${props => props.rows ? `${props.rows * 22 + 20}px` : '85px'};
  min-height: ${props => props.rows ? `${props.rows * 22 + 20}px` : '85px'};
  resize: vertical;
  line-height: 1.4;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
`; // Container de formulário

export const FormContainer = styled.form`
  display: flex;
  flex-wrap: wrap;

  input, textarea {
    ${BaseInputStyles}
  }

  textarea {
    resize: vertical;
  }
`; // Botão de campo

export const FormFieldButton = styled.button`
  padding: 6px;
  height: 32px;
  cursor: pointer;
  transition: all 0.3s;
  background: ${props => props.active ? colorAccent : colorFieldsBorder};
  border: 1px solid ${props => props.active ? colorAccent : colorFieldsBorder};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${props => props.active ? colorWhite : colorAdditional};
    width: 18px;
    height: 18px;
    transition: all 0.3s;
  }
`; // Mensagem de erro

export const ErrorMessage = styled.div`
  color: #dc3545;
  ${applyTextStyle('caption')}
  margin-top: 4px;
`; // Marca de campo obrigatório

export const RequiredMark = styled.span`
  color: #dc3545;
  margin-left: 4px;
`;